const DEFAULT_REMOTE_BASE = 'https://app.portal.se-cloud.de';

const trimTrailingSlash = (value: string): string => value.replace(/\/+$/, '');
const trimLeadingSlash = (value: string): string => value.replace(/^\/+/, '');

const detectBaseUrl = (): string => {
  const envBase = (process.env.REACT_APP_API_BASE ?? '').trim();
  if (envBase) {
    return trimTrailingSlash(envBase);
  }

  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') {
      return '';
    }
  }

  return DEFAULT_REMOTE_BASE;
};

const joinPath = (base: string, path: string): string => {
  if (!path) return base;
  const normalizedPath = trimLeadingSlash(path);
  if (!base) {
    return path.startsWith('/') ? path : `/${normalizedPath}`;
  }
  const normalizedBase = trimTrailingSlash(base);
  return `${normalizedBase}/${normalizedPath}`;
};

const BASE_URL = detectBaseUrl();
const API_URL = joinPath(BASE_URL, 'api.php');
const ASSET_BASE_URL = BASE_URL || DEFAULT_REMOTE_BASE;
const TOKEN_LOGIN_URL = joinPath(BASE_URL, 'token_login.php');
const SSO_LOGIN_URL = joinPath(BASE_URL, 'sso_login.php');

export const apiConfig = {
  baseUrl: BASE_URL,
  apiUrl: API_URL,
  assetBaseUrl: ASSET_BASE_URL,
  tokenLoginUrl: TOKEN_LOGIN_URL,
  ssoLoginUrl: SSO_LOGIN_URL
};

export const API_ENDPOINTS = {
  api: API_URL,
  tokenLogin: TOKEN_LOGIN_URL,
  ssoLogin: SSO_LOGIN_URL
};

export const buildApiActionUrl = (
  action: string,
  params?: Record<string, string | number | boolean | null | undefined>
): string => {
  const query = new URLSearchParams();
  query.set('action', action);
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value === null || value === undefined) return;
      query.set(key, String(value));
    });
  }
  return `${API_URL}?${query.toString()}`;
};

export const resolveApiUrl = (query: string): string => {
  if (!query) return API_URL;
  if (query.startsWith('http')) return query;
  if (query.startsWith('/')) {
    return joinPath(BASE_URL, trimLeadingSlash(query));
  }
  return joinPath(BASE_URL, query);
};

export const resolveAssetUrl = (path: string | null | undefined): string | null => {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) {
    return path;
  }
  return joinPath(ASSET_BASE_URL, path);
};

export const DEFAULT_FAQ_IMAGE_BASE = joinPath(ASSET_BASE_URL, 'Bilder/faq/');
